import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { PartnerOrganizationBillingModel } from '#validation';
export const CurrentUserPartnerOrganizationUpgradeEligibilityListSchema = z.array(z.object({
    id: z.uuid(),
    name: z.string(),
    canMigrate: z.boolean(),
    reason: z.string().nullable(),
    billingModel: z.enum(PartnerOrganizationBillingModel),
    parent: z.object({
        name: z.string(),
        owner: z.object({
            email: z.string().nullable(),
        }),
    }),
}));
export class CurrentUserPartnerOrganizationUpgradeEligibilityListDto extends createZodDto(CurrentUserPartnerOrganizationUpgradeEligibilityListSchema) {
}
